import * as React from 'react';
import './rvChart.css';

interface ChartNotesProps {
    notes: React.ReactNode[];
    // The last line is the "Drill down to matters" hint. It is styled like the notes above it: it is a hint, not a link.
    actionHint?: React.ReactNode;
}

// The short caveats under a chart ("Fees only...", "Information collated by...") as one tidy, left-aligned card, matching ChartFootnote.
// Display only; the wording is the chart's own.
export const ChartNotes: React.FC<ChartNotesProps> = ({ notes, actionHint }) => (
    <ul className="rv-chart-notes">
        {notes.map((note, index) => (
            <li key={index}>{note}</li>
        ))}
        {actionHint && <li className="rv-chart-notes-action">{actionHint}</li>}
    </ul>
);
